import Vue from 'vue'
import VueRouter from 'vue-router'
import subRouter from "./subRouter"
import http from '../utils/http'
import baseURL from '../utils/baseURL/baseURL'
import store from '../store/index'
import { ensureWebIdentity } from '../utils/webIdentity'

Vue.use(VueRouter)
const VueRouterPush = VueRouter.prototype.push 
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

Vue.use(VueRouter)

let routes = []

routes = routes.concat(subRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
let loadedMiceKey = ''
let miceName = ''
// let hasThemeInfo = false
router.beforeEach(async(to, from, next) => {
  const identity = await ensureWebIdentity()
  if (identity.status === 'redirecting') {
    return
  }
  if (to.meta.requiresWxIdentity && identity.status !== 'authenticated') {
    next({
      name: 'wechatRequired',
      query: {
        ...(identity.status === 'error' ? { reason: 'error' } : {}),
        redirect: to.fullPath
      }
    })
    return
  }
  if (identity.status === 'authenticated' && (to.query.code || to.query.state)) {
    const query = { ...to.query }
    delete query.code
    delete query.state
    next({ path: to.path, query, hash: to.hash, replace: true })
    return
  }

  const routeMiceLink = to.params.miceLink || ''
  const routeMiceId = to.params.miceId || ''
  const miceKey = routeMiceLink ? `link:${routeMiceLink}` : (routeMiceId ? `id:${routeMiceId}` : '')
  if (miceKey && loadedMiceKey !== miceKey) {
    let req = ''
    let res = ''
    if (routeMiceLink) {
      req = baseURL.index.getMiceInfo() + '?miceLink=' + routeMiceLink
      res = await http.get(req)
    } else if (routeMiceId) {
      req = baseURL.index.getMiceInfoById() + routeMiceId
      res = await http.post(req)
    }

    // 接口返回的会议链接字段为 linkName（部分兼容接口可能返回 miceLink）
    if (res && (res.linkName !== undefined || res.miceLink !== undefined)) {
      miceName = res ? res.miceName : ''
      store.commit('miceInfo/SET_MICE', res)
      const themeInfo = await http.get(baseURL.index.getThemeInfo() + '/' + routeMiceLink)
      store.commit('themeInfo/SET_THEME', themeInfo)
      loadedMiceKey = miceKey
      subRouter[0].meta.title = subRouter[0].children[0].meta.title = document.title = miceName
      next()
    } else {
      next('/')
    }
  
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
})

export default router
